<div data-modal class="notification-container">
  <div nxModalContent class="std-ta-center nx-margin-bottom-2m">
    <h1 nxHeadline="subsection-medium" class="nx-margin-bottom-s">
      {{ data.message }}
    </h1>
  </div>

  @if (data.button === "OK") {
    <div class="modal-actions action-btn">
      <button
        type="button"
        nxButton="secondary"
        class="std-mg-bottom-auto"
        (click)="closeDialog()"
      >
        OK
      </button>
    </div>
  }

  @if (data.button === "COSTOME") {
    <div class="modal-actions action-btn">
      <button
        type="button"
        nxButton="secondary"
        class="std-mg-bottom-auto"
        (click)="closeDialog()"
      >
        {{ data.buttonMessage }}
      </button>
    </div>
  }

  @if (data.button === "OPTIONAL") {
    <div class="modal-actions action-btn">
      <button
        type="button"
        nxButton="secondary"
        class="std-mg-bottom-auto"
        (click)="continue()"
      >
        CONTINUE
      </button>
      <button
        type="button"
        nxButton="secondary"
        class="std-mg-bottom-auto"
        (click)="closeDialog()"
      >
        CANCEL
      </button>
    </div>
  }
</div>
